var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../LayoutDesigner/LayoutDesigner", "../LayoutDesigner/LayoutElement", "../Components/NumericInputComponent", "../EventEmitter", "../Models/Configuration/VirtualScreen", "../Shared/Helper", "../../lib/interactjs/dist/interact", "../Shared/BoundingBox2D", "vue", "ts-vector-math", "vue-multiselect", "../Shared/NovoNoty"], function (require, exports, LayoutDesigner_1, LayoutElement_1, NumericInputComponent_1, EventEmitter_1, VirtualScreen_1, Helper_1, interact, BoundingBox2D_1, vue_1, ts_vector_math_1, vue_multiselect_1, NovoNoty_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var VirtualScreenDesignController = (function (_super) {
        __extends(VirtualScreenDesignController, _super);
        function VirtualScreenDesignController(locationId, virtualScreenId) {
            var _this = _super.call(this) || this;
            _this.layoutTemplate = '<div><div class="kachel"><div class="layout-element"><div class="TvScreenRect"></div></div><hr class="cyb-hr"/><div><span class="main-line">XXXParser</span><br/><span class="sub-line">YYYParser</span></div></div><div></div>';
            _this.debug = true;
            _this.loadedVirtualScreen = null;
            _this.scaleRatio = 8;
            _this.virtualWidth = 1920;
            _this.resolutionMult = 1;
            _this.finalScale = 1;
            _this.minWorkspaceWidth = 0;
            _this.minWorkspaceHeight = 0;
            _this.currentWorkspaceMaxWidth = 0;
            _this.currentWorkspaceMaxHeight = 0;
            _this.addWorkspaceWidth = 200;
            _this.addWorkspaceHeight = 150;
            var host = _this;
            host.currentLocationId = locationId;
            host.currentVirtualScreenId = virtualScreenId;
            var screenWidth = $(window).width();
            if (screenWidth < host.virtualWidth)
                host.resolutionMult = host.virtualWidth / screenWidth;
            else
                host.resolutionMult = 1;
            host.finalScale = host.scaleRatio;
            var nic = new NumericInputComponent_1.NumericInputComponent();
            host.root = $("#virtualScreenWorkSpace");
            host.currentWorkspaceMaxWidth = _this.root.width();
            host.minWorkspaceWidth = _this.currentWorkspaceMaxWidth;
            host.currentWorkspaceMaxHeight = _this.root.height() - 5;
            host.minWorkspaceHeight = _this.currentWorkspaceMaxHeight;
            host.tvScreenLayoutDesigner = new LayoutDesigner_1.LayoutDesigner(host.root, "tv");
            host.tvScreenLayoutDesigner.elementClassName = "col-xs-6 col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-4";
            host.virtualScreenLayoutDesigner = new LayoutDesigner_1.LayoutDesigner(host.root, "vi");
            host.virtualScreenLayoutDesigner.elementClassName = "ViewRect WhiteInsetShadow Dragable";
            host.virtualScreenLayoutDesigner.elementSelectedClassName = "SelectedViewRect WhiteInsetShadow Dragable";
            host.virtualScreenLayoutDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementTouched, host.ElementTouched.bind(host));
            host.virtualScreenLayoutDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementDropped, host.ElementDropped.bind(host));
            host.virtualScreenLayoutDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementMoved, host.ElementMoved.bind(host));
            host.AddEventListener("MovedOverElement", host.CreateNewElement.bind(host));
            host.virtualScreenLayoutDesigner.ApplyDropzone("#virtualScreenWorkSpace", ".Dragable");
            vue_1.default.component('multiselect', vue_multiselect_1.default);
            host.remoteDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/api/v1/virtualscreens/" + host.currentVirtualScreenId + "/rejoin",
                        type: "get", dataType: "json"
                    },
                    create: {
                        url: "/api/v1/virtualscreens",
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: "/api/v1/virtualscreens",
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (host.debug)
                        console.log("RemoteDataSource DataChange");
                    if (host.debug)
                        console.log(e.items[0]);
                },
                requestEnd: function (e) {
                    if (e.type === undefined)
                        return;
                    if (host.debug)
                        console.log("RemoteDataSource RequestEnd");
                    if (host.debug)
                        console.log(e.response);
                    var response = e.response;
                    var type = e.type;
                    if (type === "read") {
                        host.CreateLayout(response);
                        host.SetGuiValues(response);
                        host.GetRooms();
                    }
                    else {
                        if (e.response != undefined)
                            NovoNoty_1.NovoNoty.Show("Der Befehl wurde erfolgreich ausgeführt.");
                    }
                },
                error: function (e) {
                    if (host.debug) {
                        console.log("RemoteDataSource Error");
                        console.log(e.status);
                    }
                    NovoNoty_1.NovoNoty.ShowErrorDetails(e);
                }
            });
            host.rootVm = new vue_1.default({
                el: '#virtualScreenDesignerUI',
                data: {
                    name: "",
                    roomValue: null,
                    roomOptions: [],
                    x: 0,
                    y: 0,
                    rotationValue: "0",
                    rotationOptions: ["0", "90", "180", "270"]
                },
                methods: {
                    Save: function (event) {
                        host.Save();
                    },
                    DeleteLayoutElement: function (event) {
                        console.log("DeleteLayoutElement");
                        if (host.virtualScreenLayoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie einen Tv-Screen.");
                            return;
                        }
                        host.ShowTvScreenElement(host.virtualScreenLayoutDesigner.SelectedElement);
                        host.virtualScreenLayoutDesigner.DeleteSelectedLayoutElement();
                    },
                    UpdateX: function (childVm, value) {
                        if (host.virtualScreenLayoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein TV-Element");
                            return;
                        }
                        if (value < 0)
                            value = 0;
                        if (host.debug)
                            console.log("UpdateX: " + value);
                        host.virtualScreenLayoutDesigner.SelectedElement.SetX(value / host.finalScale);
                        host.SetGuiMeasurementValues(host.virtualScreenLayoutDesigner.SelectedElement);
                    },
                    UpdateY: function (childVm, value) {
                        if (host.virtualScreenLayoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein TV-Element");
                            return;
                        }
                        if (value < 0)
                            value = 0;
                        if (host.debug)
                            console.log("UpdateY: " + value);
                        host.virtualScreenLayoutDesigner.SelectedElement.SetY(value / host.finalScale);
                        host.SetGuiMeasurementValues(host.virtualScreenLayoutDesigner.SelectedElement);
                    },
                    UpdateRotation: function (value) {
                        if (host.virtualScreenLayoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein TV-Element");
                            return;
                        }
                        var vInt = parseInt(value);
                        if (host.debug)
                            console.log("UpdateRotation: " + vInt);
                        host.virtualScreenLayoutDesigner.SelectedElement.SetRotationViaSize(vInt);
                        host.virtualScreenLayoutDesigner.UnsetAllInteractions();
                        host.virtualScreenLayoutDesigner.ApplyTouchInteractionToAllElements();
                        host.virtualScreenLayoutDesigner.ApplyDragInteractionToAllElements();
                    }
                }
            });
            if (host.currentVirtualScreenId != "new")
                host.Load();
            else
                host.GetRooms();
            host.GetTvScreens();
            _this.root.parents('.scroller').first().scroll(function () { return _this.ResetDragInteractions(); });
            return _this;
        }
        VirtualScreenDesignController.prototype.GetTvScreens = function () {
            var request = $.get("/api/v1/displays");
            var host = this;
            request.done(function (data) {
                if (this.debug)
                    console.log("GetTvScreens succeeded");
                host.CreateTvScreens(data, host.layoutTemplate);
            });
            request.fail(function (data) {
                if (this.debug)
                    console.error("GetTvScreens failed : " + data);
            });
        };
        VirtualScreenDesignController.prototype.CreateTvScreens = function (physicalScreens, layoutTemplate) {
            if (this.debug)
                console.log("CreateTvScreens");
            var parent = $("#tvScreenContent");
            var maxIconWidth = 70;
            for (var _i = 0, physicalScreens_1 = physicalScreens; _i < physicalScreens_1.length; _i++) {
                var physicalScreen = physicalScreens_1[_i];
                var layoutElement = this.tvScreenLayoutDesigner.CreateLayoutElement(0, 0, 0, 0, parent, layoutTemplate, true);
                var name_1 = physicalScreen.Name;
                var dim = Math.round(physicalScreen.Dimension.Width) + "&nbsp;x&nbsp;" + Math.round(physicalScreen.Dimension.Height) + "&nbsp;mm";
                layoutElement.SetHtmlContent(name_1, ".main-line");
                layoutElement.SetHtmlContent(dim, ".sub-line");
                var ratio = physicalScreen.Dimension.Width / physicalScreen.Dimension.Height;
                layoutElement.GetSubElement(".TvScreenRect").width(maxIconWidth).height(maxIconWidth / ratio);
                layoutElement.element.children().first().attr("class", "ViewPortRect");
                layoutElement.AddOnMoveEvent(this);
                layoutElement.object = physicalScreen;
                if (physicalScreen.IsAssigned)
                    layoutElement.Hide();
            }
            if (this.debug)
                console.log("CreateTvScreens End");
        };
        VirtualScreenDesignController.prototype.GetRooms = function () {
            var request = $.get("/api/v1/rooms");
            var host = this;
            request.done(function (data) {
                if (this.debug)
                    console.log("GetRooms succeeded");
                host.CreateRoomSelection(data);
            });
            request.fail(function (data) {
                if (this.debug)
                    console.error("GetRooms failed : " + data);
            });
        };
        VirtualScreenDesignController.prototype.CreateRoomSelection = function (rooms) {
            this.rootVm.roomOptions = rooms;
            if (this.loadedVirtualScreen != null) {
                for (var _i = 0, rooms_1 = rooms; _i < rooms_1.length; _i++) {
                    var room = rooms_1[_i];
                    if (this.loadedVirtualScreen.RoomId == room.Id)
                        this.rootVm.roomValue = room;
                }
            }
        };
        VirtualScreenDesignController.prototype.ShowTvScreenElement = function (element) {
            var tvScreenElement = this.tvScreenLayoutDesigner.GetElementWithSameId(element.object);
            if (tvScreenElement != null)
                tvScreenElement.Show();
        };
        VirtualScreenDesignController.prototype.GetBoundingBox = function () {
            var boundingBoxes = new Array();
            var elements = this.virtualScreenLayoutDesigner.GetElements();
            for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                var element = elements_1[_i];
                boundingBoxes.push(element.boundingBox);
            }
            var vsBoundingBox = BoundingBox2D_1.BoundingBox2D.GetEncapsulatedBounds(boundingBoxes);
            vsBoundingBox.GrowByPoint(new ts_vector_math_1.Vector2([0, 0]));
            return vsBoundingBox;
        };
        VirtualScreenDesignController.prototype.GetData = function () {
            if (this.debug)
                console.log("GetData");
            var elements = this.virtualScreenLayoutDesigner.GetElements();
            var screens = [];
            for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
                var element = elements_2[_i];
                var displayWithPosition = element.object;
                displayWithPosition.X = Helper_1.Helper.Round(element.x * this.finalScale, 3);
                displayWithPosition.Y = Helper_1.Helper.Round(element.y * this.finalScale, 3);
                if (displayWithPosition.X < 0)
                    displayWithPosition.X = 0;
                if (displayWithPosition.Y < 0)
                    displayWithPosition.Y = 0;
                displayWithPosition.Rotation = element.rotation;
                screens.push(displayWithPosition);
            }
            var vsBoundingBox = this.GetBoundingBox();
            var virtualScreen = new VirtualScreen_1.VirtualScreen();
            virtualScreen.PhysicalScreens = screens;
            virtualScreen.LocationId = this.currentLocationId;
            var finalVirtualScreenWidth = vsBoundingBox.width * this.finalScale;
            var finalVirtualScreenHeight = vsBoundingBox.height * this.finalScale;
            virtualScreen.Dimension.Width = Math.round(finalVirtualScreenWidth);
            virtualScreen.Dimension.Height = Math.round(finalVirtualScreenHeight);
            console.log("bbw:" + finalVirtualScreenWidth);
            console.log("bbh:" + finalVirtualScreenHeight);
            console.log("bbw_r:" + virtualScreen.Dimension.Width);
            console.log("bbh_r:" + virtualScreen.Dimension.Height);
            virtualScreen.RoomId = this.rootVm.roomValue.Id;
            virtualScreen.Name = this.rootVm.name;
            if (this.currentVirtualScreenId != "new")
                virtualScreen.Id = this.currentVirtualScreenId;
            if (this.debug)
                console.log("GetData End");
            return virtualScreen;
        };
        VirtualScreenDesignController.prototype.Save = function () {
            if (this.debug)
                console.log("Save");
            if (this.rootVm.name == null || this.rootVm.name == "" || this.rootVm.name == " ") {
                NovoNoty_1.NovoNoty.ShowError("Bitte geben Sie einen Namen ein.");
                return;
            }
            if (this.rootVm.roomValue == null) {
                NovoNoty_1.NovoNoty.ShowError("Bitte wählen Sie einen Raum aus.");
                return;
            }
            if (this.virtualScreenLayoutDesigner.GetElements().length == 0) {
                NovoNoty_1.NovoNoty.ShowError("Keine TV-Screens zugewiesen.");
                return;
            }
            var virtualScreen = this.GetData();
            var data = this.remoteDataSource.data();
            if (data == null || data.length == 0)
                this.remoteDataSource.add(virtualScreen);
            else {
                var myData = this.remoteDataSource.at(0);
                myData.PhysicalScreens = virtualScreen.PhysicalScreens;
                myData.RoomId = virtualScreen.RoomId;
                myData.Name = virtualScreen.Name;
                myData.Dimension = virtualScreen.Dimension;
                myData.State = virtualScreen.State;
                myData.dirty = true;
            }
            this.remoteDataSource.sync();
            if (this.debug)
                console.log("RemoteDataSource Sync");
            if (this.debug)
                console.log("Save End");
        };
        VirtualScreenDesignController.prototype.Load = function () {
            this.remoteDataSource.read();
        };
        VirtualScreenDesignController.prototype.CreateLayout = function (data) {
            if (this.debug) {
                console.log("CreateLayout");
                console.log(data);
            }
            this.virtualScreenLayoutDesigner.ClearAllElements();
            var virtualScreen = data;
            this.loadedVirtualScreen = virtualScreen;
            var physicalScreens = virtualScreen.PhysicalScreens;
            for (var _i = 0, physicalScreens_2 = physicalScreens; _i < physicalScreens_2.length; _i++) {
                var screen_1 = physicalScreens_2[_i];
                var dwPosition = screen_1;
                var size = new ts_vector_math_1.Vector2([dwPosition.Dimension.Width, dwPosition.Dimension.Height]);
                size = size.scale(1.0 / this.finalScale);
                var layoutElement = this.virtualScreenLayoutDesigner.CreateLayoutElement(size.x, size.y, dwPosition.X / this.finalScale, dwPosition.Y / this.finalScale);
                layoutElement.SetRotationViaSize(dwPosition.Rotation);
                var description = this.GetScreenDescription(screen_1);
                layoutElement.SetHtmlContent(description);
                layoutElement.object = dwPosition;
            }
            this.ExtendWorkspace(0, 0);
            this.virtualScreenLayoutDesigner.UnsetAllInteractions();
            this.virtualScreenLayoutDesigner.ApplyTouchInteractionToAllElements();
            this.virtualScreenLayoutDesigner.ApplyDragInteractionToAllElements();
            if (this.debug)
                console.log("CreateLayout End");
        };
        VirtualScreenDesignController.prototype.ResetDragInteractions = function () {
            this.virtualScreenLayoutDesigner.UnsetAllInteractions();
            this.virtualScreenLayoutDesigner.ApplyTouchInteractionToAllElements();
            this.virtualScreenLayoutDesigner.ApplyDragInteractionToAllElements();
        };
        VirtualScreenDesignController.prototype.ExtendWorkspace = function (addWidth, addHeight, fitSize) {
            if (fitSize === void 0) { fitSize = false; }
            var bBox = this.GetBoundingBox();
            if (bBox == null)
                return;
            var newWorkspaceWidth = bBox.width + bBox.min.x + addWidth;
            if (newWorkspaceWidth < this.minWorkspaceWidth)
                newWorkspaceWidth = this.minWorkspaceWidth;
            var newWorkspaceHeight = bBox.height + bBox.min.y + addHeight;
            if (newWorkspaceHeight < this.minWorkspaceHeight)
                newWorkspaceHeight = this.minWorkspaceHeight;
            if (newWorkspaceWidth > this.currentWorkspaceMaxWidth || fitSize) {
                this.root.width(newWorkspaceWidth);
                this.currentWorkspaceMaxWidth = newWorkspaceWidth;
            }
            if (newWorkspaceHeight > this.currentWorkspaceMaxHeight || fitSize) {
                this.root.height(newWorkspaceHeight - 5);
                this.currentWorkspaceMaxHeight = newWorkspaceHeight;
            }
        };
        VirtualScreenDesignController.prototype.GetScreenDescription = function (screen) {
            return '<div style="padding:7px">' + screen.Name + "<br/>" + screen.SerialNumber + '</div>';
        };
        VirtualScreenDesignController.prototype.ElementTouched = function (sender, data) {
            var layoutElement = data.layoutElement;
            this.SetGuiMeasurementValues(layoutElement);
        };
        VirtualScreenDesignController.prototype.ElementDropped = function (sender, data) {
            var layoutElement = data.layoutElement;
            if (layoutElement.element.parent()[0].tagName.toLowerCase() == "body") {
                if (this.virtualScreenLayoutDesigner.ElementIsInDropzone == false) {
                    this.ShowTvScreenElement(layoutElement);
                    this.virtualScreenLayoutDesigner.DeleteLayoutElement(layoutElement);
                    return;
                }
                layoutElement.Parent();
                var rootRect = interact("#virtualScreenWorkSpace").getRect();
                var posX = layoutElement.x - rootRect.left;
                var posY = layoutElement.y - rootRect.top;
                layoutElement.SetPosition(posX, posY);
            }
            if (layoutElement.x < 0)
                layoutElement.SetPosition(0, layoutElement.y);
            if (layoutElement.y < 0)
                layoutElement.SetPosition(layoutElement.x, 0);
            console.log("le-x:" + layoutElement.x);
            console.log("le-y:" + layoutElement.y);
            this.ExtendWorkspace(this.addWorkspaceWidth, this.addWorkspaceHeight, true);
            this.SetGuiMeasurementValues(layoutElement);
            this.virtualScreenLayoutDesigner.UnsetAllInteractions();
            this.virtualScreenLayoutDesigner.ApplyTouchInteractionToAllElements();
            this.virtualScreenLayoutDesigner.ApplyDragInteractionToAllElements();
        };
        VirtualScreenDesignController.prototype.ElementMoved = function (sender, data) {
            var id = data.layoutId;
            this.ExtendWorkspace(this.addWorkspaceWidth, this.addWorkspaceHeight);
        };
        VirtualScreenDesignController.prototype.CreateNewElement = function (sender, data) {
            var event = data.event;
            var tvLayoutElement = data.layoutElement;
            var physicalScreen = tvLayoutElement.object;
            var width = physicalScreen.Dimension.Width / this.finalScale;
            var height = physicalScreen.Dimension.Height / this.finalScale;
            var layoutElement = this.virtualScreenLayoutDesigner.CreateLayoutElement(width, height, 0, 0, this.root);
            layoutElement.DeParent();
            layoutElement.object = tvLayoutElement.object;
            var description = this.GetScreenDescription(physicalScreen);
            layoutElement.SetHtmlContent(description);
            this.virtualScreenLayoutDesigner.ApplyAllInteractionsToAllElements();
            var clientRect = tvLayoutElement.GetRect();
            var rootRect = interact("#virtualScreenWorkSpace").getRect();
            var posX = event.pageX - (layoutElement.width.toNumber() / 2);
            var posY = event.pageY - (layoutElement.height.toNumber() / 2);
            layoutElement.SetPosition(posX, posY);
            layoutElement.StartInteraction("drag", data.event.interaction);
            tvLayoutElement.Hide();
        };
        VirtualScreenDesignController.prototype.SetGuiValues = function (data) {
            var virtualScreen = data;
            this.rootVm.name = virtualScreen.Name;
        };
        VirtualScreenDesignController.prototype.SetGuiMeasurementValues = function (layoutElement) {
            this.rootVm.x = Helper_1.Helper.Round(layoutElement.x * this.finalScale, 3);
            this.rootVm.y = Helper_1.Helper.Round(layoutElement.y * this.finalScale, 3);
            var rot = Math.round(layoutElement.rotation).toString();
            this.rootVm.rotationValue = rot;
        };
        return VirtualScreenDesignController;
    }(EventEmitter_1.EventEmitter));
    $(function () {
        if ($("#virtualScreenDesignerUI").length > 0) {
            var virtualScreenDesignController = new VirtualScreenDesignController("", window["virtualScreenId"]);
        }
    });
});
//# sourceMappingURL=VirtualScreenDesignController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/VirtualScreenDesignController.js
// module id = 374
// module chunks = 0